// ==========================================================
// strings.ts — Uygulama genelinde hardcoded UI string'leri
// i18n hazırlığı: tek dosyada toplandı, ilerleyen fazda
// dil desteği için buradan import edilecek.
// ==========================================================

// ── Sağlık skoru etiketleri ──
export const HEALTH_LABELS = {
  excellent: 'Mükemmel',
  good:      'İyi',
  warning:   'Dikkat',
  critical:  'Kritik',
} as const;

// ── Cihaz manuel açma nedenleri ──
export const MANUAL_ON_REASONS: Record<string, string> = {
  fan_fae:         'Manuel — FAE fanı kullanıcı tarafından açıldı',
  fan_circulation: 'Manuel — Sirkülasyon fanı kullanıcı tarafından açıldı',
  humidifier:      'Manuel — Nemlendirici kullanıcı tarafından açıldı',
  light:           'Manuel — LED ışık kullanıcı tarafından açıldı',
  heater:          'Manuel — Isıtıcı kullanıcı tarafından açıldı',
  cooler:          'Manuel — Soğutucu kullanıcı tarafından açıldı',
  default:         'Manuel — kullanıcı tarafından açıldı',
};

// ── Evre etiketleri ──
export const STAGE_LABELS_TR: Record<string, string> = {
  spawn_run: 'Misel Kolonizasyon',
  pinning:   'Primordia / Pinning',
  fruiting:  'Meyveleme',
  harvest:   'Hasat',
};

// ── Torba durum etiketleri ──
export const BAG_STATUS_LABELS: Record<string, string> = {
  incubation: 'Kuluçka',
  fruiting:   'Meyvelenme',
  harvested:  'Hasat Edildi',
  retired:    'Arşiv',
};

// ── Bildiri önem seviyesi etiketleri ──
export const SEVERITY_LABELS: Record<string, string> = {
  critical: 'Kritik',
  warning:  'Uyarı',
  info:     'Bilgi',
};

// ── PWA / sistem mesajları ──
export const SYSTEM_MESSAGES = {
  supabaseSyncSkipped:  'Supabase sync atlandı — localStorage ile devam ediliyor',
  offlineFallback:      'Çevrimdışı mod — son bilinen veriler gösteriliyor',
  mockModeActive:       'Mock Veri Modu',
  sensorDataStale:      'Sensör verisi eski — son güncelleme:',
} as const;
